module.exports = __webpack_public_path__ + "assets/img/cloud1.3122a1c2.webp";